// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");

function currTimeStr(param) {
  return new Date(Date.now()).toISOString();
}

function cacheMake(recalc, depVerEq) {
  return {
          recalc: recalc,
          depVerEq: depVerEq,
          depVer: undefined,
          data: undefined
        };
}

function cacheGetByDepVer(cache, depVer) {
  var cachedDepVer = cache.depVer;
  if (cachedDepVer !== undefined && Curry._2(cache.depVerEq, Caml_option.valFromOption(cachedDepVer), depVer)) {
    return cache.data;
  }
  
}

function cacheGet(cache, depVer, dep) {
  var data = cacheGetByDepVer(cache, depVer);
  if (data !== undefined) {
    return Caml_option.valFromOption(data);
  }
  cache.depVer = Caml_option.some(depVer);
  var data$1 = Curry._1(cache.recalc, dep);
  cache.data = Caml_option.some(data$1);
  return data$1;
}

function splitByRegex(str, regex) {
  return str.split(regex).map(function (strOpt) {
                return Belt_Option.getWithDefault(strOpt, "").trim();
              }).filter(function (str) {
              return str.length > 0;
            });
}

var newLineRegex = /[\n\r]/;

function multilineTextToNonEmptyLines(__x) {
  return splitByRegex(__x, newLineRegex);
}

var whitespaceDelimRegex = /[\s\n\r]/;

function getSpaceSeparatedValuesAsArray(__x) {
  return splitByRegex(__x, whitespaceDelimRegex);
}

exports.currTimeStr = currTimeStr;
exports.cacheMake = cacheMake;
exports.cacheGetByDepVer = cacheGetByDepVer;
exports.cacheGet = cacheGet;
exports.multilineTextToNonEmptyLines = multilineTextToNonEmptyLines;
exports.getSpaceSeparatedValuesAsArray = getSpaceSeparatedValuesAsArray;
/* No side effect */
